import io from 'socket.io-client';

const endpoint = 'wss://pc-food-chat.herokuapp.com';

const socket = io(endpoint);

export default socket;
